// extracted by mini-css-extract-plugin
export default {"tupacGrid":"ep-z","tupacHeader":"fp-z","tupacHeader2":"gp-z","tupacMenu":"hp-z","tupacMenu2":"ip-z","tupacMain":"jp-z","tupacMain2":"kp-z"};